/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import StacklightComponent from './StacklightComponent';
import StacklightComponentPlaceholder from './StacklightComponentPlaceholder';

interface IStacklightsComponentProps {
  templateContext: TemplateContext;
}

export default function StacklightsComponent(props: IStacklightsComponentProps): ReactElement {
  const stacklight = props.templateContext.template.stacklight;
  if (!stacklight) {
    return <></>;
  }

  return (
    <>
      {!stacklight.lampPlaceholders || stacklight.lampPlaceholders.length === 0 ? (
        <StacklightComponent templateContext={props.templateContext} stacklight={stacklight} />
      ) : (
        <StacklightComponentPlaceholder
          templateContext={props.templateContext}
          stacklight={stacklight}
          placeholder={stacklight.lampPlaceholders[0]}
          placeholderIndex={0}
        />
      )}
    </>
  );
}
